import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useSSTranslation } from "@/i18n/useSSTranslation";
import { II18nMap } from "@/i18n/en";
const campfireTear2 = "/campfire_lv-2_data.svg";
const campfireTear3 = "/campfire_lv-3_data.svg";
const campfireTear4 = "/campfire_lv-4_data.svg";

interface DrawerContent {
	streakDays: number;
}

type localizationItem = {
	key: string,
	localizationKey: keyof II18nMap,
	fallback: string,
	options?: any
}

const DrawerContent: FC<DrawerContent> = ({
	streakDays
}) => {
	const {t} = useSSTranslation();
	let image = campfireTear2;
	let localizationItems: localizationItem[] = [];
	localizationItems.push({ key: "2.1", localizationKey: "streak_drawer_text_content_tier2.1", fallback: "You started a streak." });
	localizationItems.push({ key: "2.2", localizationKey: "streak_drawer_text_content_tier2.2", fallback: "Let discipline compound." });

	if (streakDays > 1){
		image = campfireTear3;
		localizationItems = [];
		localizationItems.push({ key: "3.1", localizationKey: "streak_drawer_text_content_tier3.1", fallback: "{{x}} day streak.", options: { x: streakDays }});
		localizationItems.push({ key: "3.2", localizationKey: "streak_drawer_text_content_tier3.2", fallback: "Habits are the quiet"});
		localizationItems.push({ key: "3.3", localizationKey: "streak_drawer_text_content_tier3.3", fallback: "engine of success."});

		if (streakDays > 100){
			image = campfireTear4;
			localizationItems = [];
			localizationItems.push({ key: "4.1", localizationKey: "streak_drawer_text_content_tier4.1", fallback: "{{x}} day streak.", options: { x: streakDays }});
			localizationItems.push({ key: "4.2", localizationKey: "streak_drawer_text_content_tier4.2", fallback: "No shortcuts, no excuses"});
			localizationItems.push({ key: "4.3", localizationKey: "streak_drawer_text_content_tier4.3", fallback: "— just progress."});
		}
	}

	return (
		<Stack 
			sx={{
				justifyContent: "center",
				alignItems: "center",
				padding: "15px 15px"
			}}
		>
			<img 
				src={image}
				alt={"Campfire animated image"}
			/>
			{
				localizationItems.map(item => (
					<Typography
						key={item.key}
						sx={{
							fontSize: "34px",
							fontWeight: "400",
							textAlign: "center"
						}}
					>
						{t(item.localizationKey, item.fallback, item.options)}
					</Typography>						
				))
			}

		</Stack>
	)
}

export default DrawerContent;